module.exports = __webpack_public_path__ + "static/img/rpg_samhain.14136dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/launch/rpg_samhain.jpg
// module id = VzbD
// module chunks = 1